// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__RADar","avatar":"Detail_avatar__2G548","contextLabel":"Detail_contextLabel__Pb1xL"};